import { render } from "./Piece.vue?vue&type=template&id=1f145086&scoped=true"
import script from "./Piece.vue?vue&type=script&lang=js"
export * from "./Piece.vue?vue&type=script&lang=js"

import "./Piece.vue?vue&type=style&index=0&id=1f145086&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f145086"]])

export default __exports__